class SecondaryNav extends HTMLElement {
  constructor() {
    super();
    this.scheduledOpening = undefined;
    this.scheduledClosing = undefined;
    this.openedMenu = undefined;
    
  }

  connectedCallback() {

    this.delays = {
      open: parseInt(this.dataset.openDelay) || 250,
      switch: parseInt(this.dataset.switchDelay) || 300,
      close: parseInt(this.dataset.closeDelay) || 400
    };

    this.getAllMenus().forEach((menu) => {
      menu.addEventListener('mouseenter', this.openMenu);
      menu.addEventListener('mousemove', this.openMenu);

      const overlay = menu.querySelector('.modal-overlay');
      if (overlay) {
        overlay.style.height = `${document.body.scrollHeight}px`;
        overlay.addEventListener('mouseenter', this.handleOverlayEnter);
      }
    });

    this.addEventListener('mouseleave', this.closeAllMenus);
  }

  disconnectedCallback() {
    this.clearAllTimeouts();
    
    this.getAllMenus().forEach((menu) => {
      menu.removeEventListener('mouseenter', this.openMenu);
      menu.removeEventListener('mousemove', this.openMenu);

      const overlay = menu.querySelector('.modal-overlay');
      if (overlay) {
        overlay.removeEventListener('mouseenter', this.handleOverlayEnter);
      }
    });

    this.removeEventListener('mouseleave', this.closeAllMenus);
  }

  getAllMenus() {
    return Array.from(this.querySelectorAll('.mega-menu'));
  }

  clearAllTimeouts() {
    if (this.scheduledOpening) {
      clearTimeout(this.scheduledOpening);
      this.scheduledOpening = undefined;
    }
    if (this.scheduledClosing) {
      clearTimeout(this.scheduledClosing);
      this.scheduledClosing = undefined;
    }
  }

  handleOverlayEnter = (e) => {
    // Stop event from bubbling to prevent interference
    e.stopPropagation();
    
    // Close with 400ms delay (same as closeAllMenus)
    this.closeAllMenus();
  };

  openMenu = (e) => {
    const menuToOpen = e.currentTarget;
    
    // Don't open if we're hovering over the overlay
    if (e.target.classList.contains('modal-overlay')) {
      return;
    }
    
    // Cancel any pending close operation
    if (this.scheduledClosing) {
      clearTimeout(this.scheduledClosing);
      this.scheduledClosing = undefined;
    }
    
    // Clear any pending open operation
    if (this.scheduledOpening) {
      clearTimeout(this.scheduledOpening);
    }

    const setMenuStates = () => {
      menuToOpen.setAttribute('open', true);
      this.getAllMenus()
        .filter((menu) => menu !== menuToOpen)
        .forEach((otherMenu) => {
          otherMenu.removeAttribute('open');
        });
      this.openedMenu = menuToOpen;
    };

    // Determine delay based on current state
    let delay;
    if (this.openedMenu === menuToOpen) {
      // Already open, do nothing
      return;
    } else if (this.openedMenu) {
      // Switching between menus - use switch delay (300ms)
      delay = this.delays.switch;
    } else {
      // Opening first menu - use open delay (250ms)
      delay = this.delays.open;
    }

    this.scheduledOpening = setTimeout(setMenuStates, delay);
  };

  closeAllMenus = () => {
    // Clear any pending open operation
    if (this.scheduledOpening) {
      clearTimeout(this.scheduledOpening);
      this.scheduledOpening = undefined;
    }

    // Schedule closing with delay (400ms)
    this.scheduledClosing = setTimeout(() => {
      this.getAllMenus().forEach((menu) => {
        menu.removeAttribute('open');
      });
      this.openedMenu = undefined;
      this.scheduledClosing = undefined;
    }, this.delays.close);
  };
}

if (!customElements.get('secondary-nav')) {
  customElements.define('secondary-nav', SecondaryNav);
}